// /* global THREE */
import aframe from "aframe";

aframe.registerComponent("wave-queue", {
  init() {
    this.generators = new Set();
    this.queues = new Map();
  },
  registerGenerator(x) {
    this.generators.add(x);
  },
  tick(t, dt) {
    for (const generator of this.generators) {
      const waves = generator.next().value;
      if (waves === "done") {
        this.generators.delete(generator);
      } else if (Array.isArray(waves)) {
        if (waves.length > 0)
          waves.forEach(w => this.addWave(w));
      } else {
        this.addWave(waves);
      }
    }
  },
  take(type, n = 1) {
    if (!this.queues.has(type)) {
      return [];
    }
    const queue = this.queues.get(type);
    const toTake = [];
    for (let i = 0; i < n && queue.length; i++) {
      toTake.push(queue.shift());
    }
    return toTake;
  },
  addWave(wave) {
    const type = wave.type;
    if (!type) {
      console.error(`Unknown wave type: ${JSON.stringify(wave)}`);
      return;
    }
    if (!this.queues.has(type)) {
      this.queues.set(type, []);
    }
    this.queues.get(type).push(wave);
  },
  isDone() {
    return this.generators.size === 0;
  }
});
